import styled from "styled-components";

import { Button } from "@nested/nested-react-components";

const CurrentSelectionButton = styled(Button)`
  a {
    ${(props) => props.secondary && "border: 2px solid #eee"};
    margin: 0;
  }
`;

export { CurrentSelectionButton };
